import { render, staticRenderFns } from "./productTab.vue?vue&type=template&id=dcbf54d4&scoped=true&"
import script from "./productTab.vue?vue&type=script&lang=js&"
export * from "./productTab.vue?vue&type=script&lang=js&"
import style0 from "./productTab.vue?vue&type=style&index=0&id=dcbf54d4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbf54d4",
  null
  
)

export default component.exports